import { BREAKPOINTS } from '@ag1/ui';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';

export function useTestimonialsMobileSlider() {
  const [selectedSlide, setSelectedSlide] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    breakpoints: {
      [`(min-width: ${BREAKPOINTS.s}px)`]: {
        active: false
      }
    }
  });

  const handleThumbClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const handleSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedSlide(emblaApi.selectedScrollSnap());
  }, [emblaApi, setSelectedSlide]);

  useEffect(() => {
    if (!emblaApi) return;
    handleSelect();
    emblaApi.on('select', handleSelect);
    emblaApi.on('reInit', handleSelect);
  }, [emblaApi, handleSelect]);

  return {
    ref: emblaRef,
    selectedSlide,
    handleThumbClick
  };
}
